'use strict';

import settings from '../settings';
import { HttpContext } from '../utils/httpContext';

class UzenetService {
  async GetErtesiteseim({ utolsoUzenetId }) {
    const url = settings.baseUrl + 'Api/Uzenet/GetErtesiteseim';
    let data = { utolsoUzenetId, mennyiseg: settings.perPage };
    const result = await HttpContext.post({ url, data });
    return result;
  }
}

let instance = new UzenetService();
export { instance as uzenetService };
